import globalen from './languages/en/global.json';
import globalturkish from './languages/tr/global-tr.json';
import companyen from './languages/en/company.json';
import accountsettingsen from './languages/en/account-settings.json';
import companyturkish from './languages/tr/company.json';
import companyes from './languages/es/company.json';
import entitiesen from './languages/en/myentity.json';
import entitieses from './languages/es/myentity.json';
import entitiestr from './languages/tr/myentity.json';
import managecustomsscreenes from './languages/es/manage-customs.json';
import managecustomsscreentr from './languages/tr/manage-customs.json';
import managecustomsscreenen from './languages/en/manage-customs.json';
import accountsettingsturkish from './languages/tr/account-settings.json';
import mydashboarden from './languages/en/my-dashbord.json';
import mydashboardturkish from './languages/tr/my-dashbord.json';
import notificationsen from './languages/en/notifications.json';
import notificationsturkish from './languages/tr/notifications.json';
import invitepartneren from './languages/en/invite-partners.json';
import invitepartnerturkish from './languages/tr/invite-partners.json';
import manageordersen from './languages/en/manage-orders.json';
import manageordersturkish from './languages/tr/manage-orders.json';
import managepricingen from './languages/en/manage-pricing.json';
import managepricingturkish from './languages/tr/manage-pricing.json';
import managepricinges from './languages/es/manage-pricing.json';
import managebookingen from './languages/en/manage-bookings.json';
import managebookingturkish from './languages/tr/manage-bookings.json';
import manageshipmentsen from './languages/en/manage-shipments.json';
import manageshipmentsturkish from './languages/tr/manage-shipments.json';
import globalleftmenuen from './languages/en/global-left-menu.json';
import globalleftmenuturkish from './languages/tr/global-left-menu.json';
import mysuppliersen from './languages/en/my-suppliers.json';
import mysuppliersturkish from './languages/tr/my-suppliers.json';
import systemsettingsen from './languages/en/system-settings.json';
import systemsettingsturkish from './languages/tr/system-settings.json';
import toasten from './languages/en/toast.json';
import toastturkish from './languages/tr/toast.json';
import statusen from './languages/en/status.json';
import statusturkish from './languages/tr/status.json';
import dashboarden from './languages/en/dashboard.json';
import dashboardtr from './languages/tr/dashboard.json';
import dashboardes from './languages/es/dashboard.json';
import accountsettingses from './languages/es/account-settings.json';
import globalleftmenues from './languages/es/global-left-menu.json';
import globales from './languages/es/global.json';
import invitepartneres from './languages/es/invite-partners.json';
import manageshipmentses from './languages/es/manage-shipments.json';
import mydashboardes from './languages/es/my-dashbord.json';
import mysupplierses from './languages/es/my-suppliers.json';
import notificationses from './languages/es/notifications.json';
import statuses from './languages/es/status.json';
import systemsettingses from './languages/es/system-settings.json';
import managebookinges from './languages/es/manage-bookings.json';
import toastes from './languages/es/toast.json';
import manageorderses from './languages/es/manage-orders.json';
import timelineen from './languages/en/timeline.json';
import timelinees from './languages/es/timeline.json';
import timelinetr from './languages/tr/timeline.json';
import datepickereng from './languages/en/date-picker.json';
import datepickeres from './languages/es/date-picker.json';
import datepickertr from './languages/tr/date-picker.json';
import { getUserLanguage } from './service/authService';
import mycustomsen from './languages/en/my-customs.json';
import mycustomses from './languages/es/my-customs.json';
import mycustomstr from './languages/tr/my-customs.json';
import transferRightsen from './languages/en/transfer-rights.json';
import transferRightses from './languages/es/transfer-rights.json';
import transferRightsstr from './languages/tr/transfer-rights.json';
import manageconsolidationen from './languages/en/manage-consolidation.json';
import manageconsolidationes from './languages/es/manage-consolidation.json';
import manageconsolidationtr from './languages/tr/manage-consolidation.json';
import myconsolevitroen from './languages/en/my-console-vitro.json';
import myconsolevitroes from './languages/es/my-console-vitro.json';
import myconsolevitrotr from './languages/tr/my-console-vitro.json';

const setLanguage = () => {
  return {
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    lng: getUserLanguage() || 'en',
    resources: {
      en: {
        global: globalen,
        company: companyen,
        myentity: entitiesen,
        accountsettings: accountsettingsen,
        mydashboard: mydashboarden,
        notifications: notificationsen,
        invitepartner: invitepartneren,
        manageorders: manageordersen,
        managepricing: managepricingen,
        managebooking: managebookingen,
        managecustoms: managecustomsscreenen,
        manageshipments: manageshipmentsen,
        globalleftmenu: globalleftmenuen,
        mysuppliers: mysuppliersen,
        systemsettings: systemsettingsen,
        toast: toasten,
        status: statusen,
        dashboard: dashboarden,
        timeline: timelineen,
        datepicker: datepickereng,
        mycustoms: mycustomsen,
        transferRights: transferRightsen,
        myconsole: manageconsolidationen,
        myconsolevitro: myconsolevitroen,
      },
      tr: {
        global: globalturkish,
        company: companyturkish,
        myentity: entitiestr,
        accountsettings: accountsettingsturkish,
        mydashboard: mydashboardturkish,
        notifications: notificationsturkish,
        invitepartner: invitepartnerturkish,
        manageorders: manageordersturkish,
        managepricing: managepricingturkish,
        managebooking: managebookingturkish,
        managecustoms: managecustomsscreentr,
        manageshipments: manageshipmentsturkish,
        globalleftmenu: globalleftmenuturkish,
        mysuppliers: mysuppliersturkish,
        systemsettings: systemsettingsturkish,
        toast: toastturkish,
        status: statusturkish,
        dashboard: dashboardtr,
        timeline: timelinetr,
        datepicker: datepickertr,
        mycustoms: mycustomstr,
        transferRights: transferRightsstr,
        myconsole: manageconsolidationtr,
        myconsolevitro: myconsolevitrotr,
      },
      es: {
        global: globales,
        company: companyes,
        myentity: entitieses,
        dashboard: dashboardes,
        accountsettings: accountsettingses,
        globalleftmenu: globalleftmenues,
        invitepartner: invitepartneres,
        manageshipments: manageshipmentses,
        mydashboard: mydashboardes,
        mysuppliers: mysupplierses,
        notifications: notificationses,
        status: statuses,
        systemsettings: systemsettingses,
        managebooking: managebookinges,
        managecustoms: managecustomsscreenes,
        toast: toastes,
        manageorders: manageorderses,
        managepricing: managepricinges,
        timeline: timelinees,
        datepicker: datepickeres,
        mycustoms: mycustomses,
        transferRights: transferRightses,
        myconsole: manageconsolidationes,
        myconsolevitro: myconsolevitroes,
      },
    },
  };
};

export default setLanguage;
